// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__JCW6N","unreadBadge":"styles_unreadBadge__mh08q","modalContent":"styles_modalContent__1DQ6B","modal":"styles_modal__4pzF9"};